// Cliente da ampliacao por IA (Fase 4 da Biblioteca de Fotos, DA-071).
//
// O trabalho pesado (TensorFlow.js + UpscalerJS) roda num Web Worker
// (upscale-worker.ts) — fora do thread principal, pra a tela nunca travar.
// Aqui so criamos o worker, repassamos o progresso e devolvemos o resultado.

// Limite de seguranca: se a ampliacao passar disso, e cancelada. Evita o
// processo ficar pendurado pra sempre. O motor WASM (CPU) e mais lento, entao
// a margem e generosa.
const TIMEOUT_MS = 360000;

// Amplia `fotoUrl` por IA e devolve a imagem ampliada como Blob WebP.
// onProgresso recebe o andamento (0 a 1) pra alimentar a barra de progresso.
export function ampliarFotoParaMaster(
  fotoUrl: string,
  onProgresso?: (rate: number) => void,
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('./upscale-worker.ts', import.meta.url), {
      type: 'module',
    });
    let encerrado = false;
    const encerrar = () => {
      if (encerrado) return;
      encerrado = true;
      clearTimeout(timer);
      worker.terminate();
    };
    const timer = setTimeout(() => {
      reject(new Error('a ampliação demorou demais e foi cancelada — tente de novo'));
      encerrar();
    }, TIMEOUT_MS);

    worker.onmessage = (e: MessageEvent) => {
      const m = e.data;
      if (m?.tipo === 'progresso') {
        onProgresso?.(Math.min(1, Math.max(0, Number(m.valor) || 0)));
      } else if (m?.tipo === 'pronto') {
        resolve(m.blob as Blob);
        encerrar();
      } else if (m?.tipo === 'erro') {
        reject(new Error(m.msg || 'falha ao ampliar a foto'));
        encerrar();
      }
    };
    worker.onerror = (e) => {
      reject(new Error(e.message || 'falha no processamento da imagem'));
      encerrar();
    };

    worker.postMessage({ fotoUrl });
  });
}
